import React, { useEffect } from "react";
import { FaInstagram, FaLinkedinIn, FaEnvelope, FaTwitter } from "react-icons/fa";
import { motion } from "framer-motion";
import "../styles/Confetti.css";

const Contact = () => {
  useEffect(() => {
    const createConfetti = () => {
      const confettiContainer = document.querySelector(".confetti-container");
      if (!confettiContainer) return;

      const confettiCount = 30;
      const colors = ["#FFC107", "#29B6F6", "#FF5722", "#8BC34A", "#9C27B0"];

      for (let i = 0; i < confettiCount; i++) {
        const confetti = document.createElement("div");
        confetti.classList.add("confetti");
        confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        confetti.style.left = `${Math.random() * 100}%`;
        confetti.style.animationDelay = `${Math.random() * 3}s`;

        confettiContainer.appendChild(confetti);
        confetti.addEventListener("animationend", () => confetti.remove());
      }
    };

    createConfetti();
    const interval = setInterval(createConfetti, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex min-h-screen bg-black text-white transition-all duration-300">
      <div className="flex flex-col flex-grow transition-all duration-300 overflow-hidden">
        <main className="flex-1 w-full max-w-screen-xl mx-auto px-6 py-16 relative">
          <div className="confetti-container absolute top-0 left-0 w-full h-full pointer-events-none"></div>

          {/* Contact Header Section (Diagonal Layout) */}
          <section className="container mx-auto px-6 md:px-16 py-24 flex flex-col-reverse md:flex-row items-center gap-16">
            {/* Left Content */}
            <motion.div
              className="w-full md:w-1/2"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              <p className="text-4xl md:text-5xl ">Get in Touch</p>
              <p className="mt-6 text-lg text-gray-300">
                Have questions about our AI solutions? Want to collaborate? Reach out to us.
              </p>

              {/* CTA Buttons */}
              <div className="mt-8 flex space-x-4">
                <a
                  href="mailto:yeshuraja07@gmail.com"
                  className="bg-gray-700 text-white px-6 py-3 rounded-full hover:bg-gray-600 transition"
                >
                  Contact Us
                </a>
                <a
                  href="https://www.linkedin.com/in/yesvanthraja-d-7841b324a/"
                  target="_blank"
                  className="border border-gray-600 px-6 py-3 rounded-full text-white hover:bg-gray-800 transition"
                >
                  LinkedIn →
                </a>
              </div>
            </motion.div>

            {/* Right Image (Responsive & Diagonal Placement) */}
            <motion.div
              className="w-full md:w-1/2 flex justify-end"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              <img
                src="/assets/img11.avif"
                alt="Contact"
                className="rounded-3xl w-full h-auto md:h-[500px] object-cover shadow-xl"
              />
            </motion.div>
          </section>

          {/* Follow Us Section (Reverse Diagonal for Responsiveness) */}
          <section className="container mx-auto px-6 md:px-16 py-24 flex flex-col md:flex-row items-center gap-16">
            {/* Left Image (Diagonal Placement) */}
            <motion.div
              className="w-full md:w-1/2 flex justify-start"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              <img
                src="/assets/img9.avif"
                alt="Social Media"
                className="rounded-3xl w-full h-auto md:h-[500px] object-cover shadow-xl"
              />
            </motion.div>

            {/* Right Content */}
            <motion.div
              className="w-full md:w-1/2"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            >
              <h2 className="text-4xl md:text-5xl font-bold">Follow Us</h2>
              <p className="mt-6 text-lg text-gray-300">
                Stay updated on the latest AI innovations and product launches.
              </p>

              <div className="mt-8 flex space-x-6">
                <a href="https://www.instagram.com" target="_blank" className="text-white text-3xl hover:text-yellow-500 transition">
                  <FaInstagram />
                </a>
                <a href="https://www.twitter.com" target="_blank" className="text-white text-3xl hover:text-blue-400 transition">
                  <FaTwitter />
                </a>
                <a href="https://www.linkedin.com/in/yesvanthraja-d-7841b324a/" target="_blank" className="text-white text-3xl hover:text-blue-600 transition">
                  <FaLinkedinIn />
                </a>
                <a href="mailto:yeshuraja07@gmail.com" className="text-white text-3xl hover:text-red-400 transition">
                  <FaEnvelope />
                </a>
              </div>
            </motion.div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Contact;


// import React, { useEffect, useState } from "react";
// import { FaInstagram, FaLinkedinIn, FaEnvelope, FaTwitter } from "react-icons/fa";
// import { motion } from "framer-motion";
// import Sidebar from "../components/SideBar";
// import "../styles/Confetti.css";

// const Contact = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);

//   useEffect(() => {
//     const createConfetti = () => {
//       const confettiContainer = document.querySelector(".confetti-container");
//       if (!confettiContainer) return;

//       const confettiCount = 30;
//       const colors = ["#FFC107", "#29B6F6", "#FF5722", "#8BC34A", "#9C27B0"];

//       for (let i = 0; i < confettiCount; i++) {
//         const confetti = document.createElement("div");
//         confetti.classList.add("confetti");
//         confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
//         confetti.style.left = `${Math.random() * 100}%`;
//         confetti.style.animationDelay = `${Math.random() * 3}s`;

//         confettiContainer.appendChild(confetti);
//         confetti.addEventListener("animationend", () => confetti.remove());
//       }
//     };

//     createConfetti();
//     const interval = setInterval(createConfetti, 5000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="flex min-h-screen bg-black text-white transition-all duration-300">
//       {/* Sidebar */}
//       <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

//       {/* Main Content */}
//       <div
//         className={`flex flex-col flex-grow transition-all duration-300 overflow-hidden ${
//           isSidebarOpen ? "pl-64" : "pl-20"
//         }`}
//       >
//         <main className="flex-1 w-full max-w-screen-xl mx-auto px-6 py-16 relative">
//           <div className="confetti-container absolute top-0 left-0 w-full h-full pointer-events-none"></div>

//           {/* Contact Header Section (Diagonal Layout) */}
//           <section className="container mx-auto px-6 md:px-16 py-24 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
//             {/* Left Content */}
//             <motion.div
//               className="md:col-span-1"
//               initial={{ opacity: 0, x: -50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 1 }}
//             >
//               <p className="text-4xl md:text-5xl">Get in Touch</p>
//               <p className="mt-6 text-lg text-gray-300">
//                 Have questions about our AI solutions? Want to collaborate? Reach out to us.
//               </p>

//               {/* CTA Buttons */}
//               <div className="mt-8 flex space-x-4">
//                 <a
//                   href="mailto:example@gmail.com"
//                   className="bg-gray-700 text-white px-6 py-3 rounded-full hover:bg-gray-600 transition"
//                 >
//                   Contact Us
//                 </a>
//                 <a
//                   href="https://www.linkedin.com"
//                   className="border border-gray-600 px-6 py-3 rounded-full text-white hover:bg-gray-800 transition"
//                 >
//                   LinkedIn →
//                 </a>
//               </div>
//             </motion.div>

//             {/* Right Image (Diagonal Placement) */}
//             <motion.div
//               className="md:col-span-1 flex justify-end"
//               initial={{ opacity: 0, x: 50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 1 }}
//             >
//               <img
//                 src="/assets/img11.avif"
//                 alt="Contact"
//                 className="rounded-3xl w-full h-[500px] object-cover shadow-xl"
//               />
//             </motion.div>
//           </section>

//           {/* Follow Us Section (Reverse Diagonal) */}
//           <section className="container mx-auto px-6 md:px-16 py-24 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
//             {/* Left Image (Diagonal Placement) */}
//             <motion.div
//               className="md:col-span-1 flex justify-start"
//               initial={{ opacity: 0, x: -50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 1 }}
//             >
//               <img
//                 src="/assets/img9.avif"
//                 alt="Social Media"
//                 className="rounded-3xl w-full h-[500px] object-cover shadow-xl"
//               />
//             </motion.div>

//             {/* Right Content */}
//             <motion.div
//               className="md:col-span-1"
//               initial={{ opacity: 0, x: 50 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 1 }}
//             >
//               <h2 className="text-4xl md:text-5xl font-bold">Follow Us</h2>
//               <p className="mt-6 text-lg text-gray-300">
//                 Stay updated on the latest AI innovations and product launches.
//               </p>

//               <div className="mt-8 flex space-x-6">
//                 <a href="https://www.instagram.com" className="text-white text-3xl hover:text-yellow-500 transition">
//                   <FaInstagram />
//                 </a>
//                 <a href="https://www.twitter.com" className="text-white text-3xl hover:text-blue-400 transition">
//                   <FaTwitter />
//                 </a>
//                 <a href="https://www.linkedin.com" className="text-white text-3xl hover:text-blue-600 transition">
//                   <FaLinkedinIn />
//                 </a>
//                 <a href="mailto:example@gmail.com" className="text-white text-3xl hover:text-red-400 transition">
//                   <FaEnvelope />
//                 </a>
//               </div>
//             </motion.div>
//           </section>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default Contact;







// import React, { useEffect, useState } from "react";
// import { FaInstagram, FaLinkedinIn, FaEnvelope, FaTwitter } from "react-icons/fa";
// import Sidebar from "../components/SideBar";
// import "../styles/Confetti.css";

// const Contact = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);

//   useEffect(() => {
//     const createConfetti = () => {
//       const confettiContainer = document.querySelector(".confetti-container");
//       if (!confettiContainer) return;

//       const confettiCount = 30;
//       const colors = ["#FFC107", "#29B6F6", "#FF5722", "#8BC34A", "#9C27B0"];

//       for (let i = 0; i < confettiCount; i++) {
//         const confetti = document.createElement("div");
//         confetti.classList.add("confetti");
//         confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
//         confetti.style.left = `${Math.random() * 100}%`;
//         confetti.style.animationDelay = `${Math.random() * 3}s`;

//         confettiContainer.appendChild(confetti);
//         confetti.addEventListener("animationend", () => confetti.remove());
//       }
//     };

//     createConfetti();
//     const interval = setInterval(createConfetti, 5000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="flex min-h-screen bg-black text-gray-800 transition-all duration-300">
//       {/* Sidebar */}
//       <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />

//       {/* Main Content Area (Fixes Overlapping Issue) */}
//       <div
//         className={`flex flex-col flex-grow transition-all duration-300 overflow-hidden ${
//           isSidebarOpen ? "pl-64" : "pl-20"
//         }`}
//       >
//         <main className="flex-1 w-full max-w-screen-xl mx-auto px-6 py-16 relative">
//           <div className="confetti-container absolute top-0 left-0 w-full h-full pointer-events-none"></div>

//           <div className="container mx-auto space-y-12">
//             {/* Contact Header */}
//             <div
//               className="bg-white shadow-lg rounded-3xl p-6 md:p-8 text-center"
//               style={{
//                 background: `radial-gradient(circle at 30% 50%, #a8edea, #fed6e3)`,
//               }}
//             >
//               <h2 className="text-2xl md:text-4xl mb-4 text-black">We’d Love to Hear From You!</h2>
//               <p className="text-gray-500 text-sm md:text-lg mb-6">
//                 Whether you have a question about our services, pricing, or anything else, our team is
//                 ready to answer all your questions.
//               </p>
//               <a
//                 href="mailto:example@gmail.com"
//                 className="inline-block bg-yellow-400 text-white text-sm md:text-lg font-medium py-2 px-4 md:py-3 md:px-6 rounded-full shadow-md hover:bg-yellow-500 transition-all"
//               >
//                 Email Us
//               </a>
//             </div>

//             {/* Quick Contact Options */}
//             <div
//               className="bg-white shadow-lg rounded-3xl p-6 md:p-8 text-center"
//               style={{
//                 background: `radial-gradient(circle at 30% 50%, #a8edea, #fed6e3)`,
//               }}
//             >
//               <h2 className="text-2xl md:text-3xl font-bold mb-6 text-black">Quick Contact Options</h2>
//               <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6">
//                 <a href="mailto:example@gmail.com" className="contact-btn">
//                   <FaEnvelope />
//                   <span>Email Us</span>
//                 </a>
//                 <a href="https://www.instagram.com" className="contact-btn" target="_blank" rel="noopener noreferrer">
//                   <FaInstagram />
//                   <span>Instagram</span>
//                 </a>
//                 <a href="https://www.linkedin.com" className="contact-btn" target="_blank" rel="noopener noreferrer">
//                   <FaLinkedinIn />
//                   <span>LinkedIn</span>
//                 </a>
//               </div>
//             </div>

//             {/* Follow Us Section */}
//             <div
//               className="bg-white shadow-lg rounded-3xl p-6 md:p-8 text-center"
//               style={{
//                 background: `radial-gradient(circle at 30% 50%, #a8edea, #fed6e3)`,
//               }}
//             >
//               <h2 className="text-2xl md:text-3xl font-bold mb-6 text-black">Follow Us on Social Media</h2>
//               <div className="flex justify-center space-x-4 md:space-x-6">
//                 <a href="https://www.instagram.com" className="social-icon">
//                   <FaInstagram className="icon-size" />
//                 </a>
//                 <a href="https://www.twitter.com" className="social-icon">
//                   <FaTwitter className="icon-size" />
//                 </a>
//                 <a href="https://www.linkedin.com" className="social-icon">
//                   <FaLinkedinIn className="icon-size" />
//                 </a>
//                 <a href="mailto:example@gmail.com" className="social-icon">
//                   <FaEnvelope className="icon-size" />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default Contact;

// import React, { useEffect } from "react";
// import { FaInstagram, FaLinkedinIn, FaEnvelope, FaTwitter } from "react-icons/fa";
// import "../styles/Confetti.css";

// const Contact = () => {
//   useEffect(() => {
//     const createConfetti = () => {
//       const confettiContainer = document.querySelector(".confetti-container");
//       if (!confettiContainer) return;

//       const confettiCount = 30;
//       const colors = ["#FFC107", "#29B6F6", "#FF5722", "#8BC34A", "#9C27B0"];

//       for (let i = 0; i < confettiCount; i++) {
//         const confetti = document.createElement("div");
//         confetti.classList.add("confetti");
//         confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
//         confetti.style.left = `${Math.random() * 100}%`;
//         confetti.style.animationDelay = `${Math.random() * 3}s`;

//         confettiContainer.appendChild(confetti);
//         confetti.addEventListener("animationend", () => confetti.remove());
//       }
//     };

//     createConfetti();
//     const interval = setInterval(createConfetti, 5000);

//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="min-h-screen bg-black text-gray-800 py-16 px-4 md:py-24 md:px-8 relative overflow-hidden">
//       <div className="confetti-container absolute top-0 left-0 w-full h-full pointer-events-none"></div>

//       <div className="container mx-auto space-y-12">
//         <div
//           className="bg-white shadow-lg rounded-3xl p-6 md:p-8 text-center"
//           style={{
//             background: `radial-gradient(circle at 30% 50%, #a8edea, #fed6e3)`,
//           }}
//         >
//           <h2 className="text-2xl md:text-4xl mb-4 text-black">
//             We’d Love to Hear From You!
//           </h2>
//           <p className="text-gray-500 text-sm md:text-lg mb-6">
//             Whether you have a question about our services, pricing, or anything else, our team is
//             ready to answer all your questions.
//           </p>
//           <a
//             href="mailto:example@gmail.com"
//             className="inline-block bg-yellow-400 text-white text-sm md:text-lg font-medium py-2 px-4 md:py-3 md:px-6 rounded-full shadow-md hover:bg-yellow-500 transition-all"
//           >
//             Email Us
//           </a>
//         </div>
//         <div
//           className="bg-white shadow-lg rounded-3xl p-6 md:p-8 text-center"
//           style={{
//             background: `radial-gradient(circle at 30% 50%, #a8edea, #fed6e3)`,
//           }}
//         >
//           <h2 className="text-2xl md:text-3xl font-bold mb-6 text-black">Quick Contact Options</h2>
//           <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6">
//             <a
//               href="mailto:example@gmail.com"
//               className="flex items-center justify-center space-x-2 text-blue-600 border border-blue-600 py-2 px-4 md:py-3 md:px-6 rounded-full hover:bg-blue-100 transition-all"
//             >
//               <FaEnvelope />
//               <span>Email Us</span>
//             </a>
//             <a
//               href="https://www.instagram.com"
//               className="flex items-center justify-center space-x-2 text-blue-600 border border-blue-600 py-2 px-4 md:py-3 md:px-6 rounded-full hover:bg-blue-100 transition-all"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaInstagram />
//               <span>Instagram</span>
//             </a>
//             <a
//               href="https://www.linkedin.com"
//               className="flex items-center justify-center space-x-2 text-blue-600 border border-blue-600 py-2 px-4 md:py-3 md:px-6 rounded-full hover:bg-blue-100 transition-all"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaLinkedinIn />
//               <span>LinkedIn</span>
//             </a>
//           </div>
//         </div>

//         <div
//           className="bg-white shadow-lg rounded-3xl p-6 md:p-8 text-center"
//           style={{
//             background: `radial-gradient(circle at 30% 50%, #a8edea, #fed6e3)`,
//           }}
//         >
//           <h2 className="text-2xl md:text-3xl font-bold mb-6 text-black">
//             Follow Us on Social Media
//           </h2>
//           <div className="flex justify-center space-x-4 md:space-x-6">
//             <a
//               href="https://www.instagram.com"
//               className="p-3 md:p-4 bg-gray-200 text-gray-700 rounded-full hover:bg-yellow-400 hover:text-white transition-all"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaInstagram className="text-xl md:text-2xl" />
//             </a>
//             <a
//               href="https://www.twitter.com"
//               className="p-3 md:p-4 bg-gray-200 text-gray-700 rounded-full hover:bg-blue-400 hover:text-white transition-all"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaTwitter className="text-xl md:text-2xl" />
//             </a>
//             <a
//               href="https://www.linkedin.com"
//               className="p-3 md:p-4 bg-gray-200 text-gray-700 rounded-full hover:bg-blue-600 hover:text-white transition-all"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <FaLinkedinIn className="text-xl md:text-2xl" />
//             </a>
//             <a
//               href="mailto:example@gmail.com"
//               className="p-3 md:p-4 bg-gray-200 text-gray-700 rounded-full hover:bg-yellow-400 hover:text-white transition-all"
//             >
//               <FaEnvelope className="text-xl md:text-2xl" />
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contact;
